
const HeroSection = () => {
  return (
    <div 
      className="elementor-element elementor-element-9232cd3 e-flex e-con-boxed e-con e-parent" 
      data-id="9232cd3" 
      data-element_type="container"
    >
      <div className="e-con-inner">
        <div 
          className="elementor-element elementor-element-0e90a93 e-con-full e-flex e-con e-child" 
          data-id="0e90a93" 
          data-element_type="container" 
          data-settings='{"background_background":"classic"}'
        >
          {/* Título Principal H1 */}
          <div 
            className="elementor-element elementor-element-901de4b elementor-widget elementor-widget-heading" 
            data-id="901de4b" 
            data-element_type="widget" 
            data-widget_type="heading.default"
          >
            <div className="elementor-widget-container">
              <h1 className="elementor-heading-title elementor-size-default">
                Jogue com Segurança. Ganhe em Grande. Compare os Melhores Casinos Legais em Portugal
              </h1>
            </div>
          </div>

          {/* Descrição e Lista de Benefícios */}
          <div 
            className="elementor-element elementor-element-5ad0b53 elementor-widget elementor-widget-text-editor" 
            data-id="5ad0b53" 
            data-element_type="widget" 
            data-widget_type="text-editor.default"
          >
            <div className="elementor-widget-container">
              <p>
                Descubra casinos licenciados e confiáveis. Encontre os maiores bónus, os jogos 
                mais populares e pagamentos rápidos e seguros — tudo num só lugar.
              </p>
              <p>
                🎰 100% Regulamentados | 🎁 Melhores Bónus | 🔒 Seguros &amp; Verificados<br />
                👉 Comece a comparar agora com o Casinonlineportugal – Casinonlineportugal.site
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;